export default {
  main: '#32555C',
  secondary: '#563642',
  contrastingColor: '#ffffff',
  priceColor: '#32555C',
  entryBackground: '#32555C',
  menuBackgroundColor: '#32555C',
  menuTextColor: '#ffffff',
};
